/*
 * 文档
 * Created by luzhuang
 */

import React, { Component } from 'react';

//章节
import Section0             from './Section0';
import Section1             from './Section1';
import Section2             from './Section2';
import Section3             from './Section3';
import Section4             from './Section4';
import Section5             from './Section5';
import Section6             from './Section6';
import Section7             from './Section7';
import Section8             from './Section8';
import Section9             from './Section9';
import Section10            from './Section10';
import Section11            from './Section11';
import Section12            from './Section12';
import Section13            from './Section13';
import Section14            from './Section14';

//章节附件
import Index             from './fujian/index.js';
import './index.css';

// import enclosureContent            from './enclosureContent';

import { message } from 'antd';

//背景图片
// import background11 from './assets/img/background11.png';
//内容样式
const background11Style = {
  position:'relative',
  // background:'url('+background11+')',
  backgroundSize:'100% 100%',
  padding:'10px',
  borderRadius:'6px',
  fontSize:'16px',
  fontFamily:'黑体',
  height:'100%',
  overflowY:'auto',
  overflowX:'hidden',
  onselectstart:'return false',
  unselectable:'on',
  WebkitTouchCallout: 'none',
  WebkitUserSelect: 'none',
  KhtmlUserSelect: 'none',
  MozUserSelect: 'none',
  MsUserSelect: 'none',
  userSelect: 'none',
  zIndex:10,
};


class Article extends Component {
    constructor (props) {
        super(props);
        this.state = {
          userName:window.sessionStorage.getItem('userName')?JSON.parse(window.sessionStorage.getItem('userName')):'暂无姓名',
          //附件模态框
          visible:false,
          //附件模态框id
          id:'',
          //附件模态框标题
          title:'',
        };
    }

    componentWillMount () {
       const { userName } = this.state;
       if(userName === '暂无姓名'){
         window.location.href = window.location.origin + window.location.pathname + '#/';
       }
    }

    componentDidMount () {
        var url = window.location.href;
        //获取到 &/ 后边的值
        const keys = url.split('&/')[1];
        if (keys) {
            let anchorElement = this.refs.divDome.getElementsByClassName('point');
            var data = [];
            for (let i = 0; i < anchorElement.length; i++) {
                let ttDom = anchorElement[i];
                var object = {};
                if (ttDom.hasAttribute && ttDom.hasAttribute('name')) {
                    let keys = ttDom.attributes['name'].value;
                    let id = ttDom.attributes['id'].value;
                    object['keys'] = keys;
                    object['id'] = id;
                }
                data.push(object);
            }

            //根据左侧点击的key值，匹配出页面中的 id, 并给其定位；
            const statusZero = data.filter((v, i) => (v.keys === keys));
            if(statusZero.length<1){
                message.error('陈列内容出错，刷新重新尝试！')
                setInterval(function(){
                 window.location.href = window.location.origin + window.location.pathname + '#/data';
                },2000)
                return;
            }
            const status = data.filter((v, i) => (v.keys === keys))[0].id;
            
            //确定dom,
            const domeee = document.getElementById(status);
            //确定dom节点处距离文档顶部的距离
            const pointTop = domeee.offsetTop;

            //获取有滑块的div
            const domeOne = document.getElementById('one');
            //给其赋予高度值；  其高度等于获取的节点距离文档顶部的高度；
            domeOne.scrollTop = pointTop - '' - 70;

        } else {
            //获取有滑块的div
            const domeOne = document.getElementById('one');
            domeOne.scrollTop = -70;
        }
    }

    enclosureShow = (id,title) => {
        this.setState({
            visible: true,
            id:id,
            title:title
        });
    };

    enclosureClose = () => {
        this.setState({
            visible: false,
            id:'',
            title:''
        });
    };

    render () {
        const { userName,visible,id,title } = this.state;
        return (
            <div id='one' style={background11Style}>
                <div style={{position:'fixed',width:'80%',height:'100%',zIndex:1,overflow:'hidden'}}>
                  <div style={{
                    width:'100%',
                    height:'180%',
                    webkitTransform: 'rotate(45deg)',/*Safari 4+,Google Chrome 1+ */
                    mozTransform: 'rotate(45deg)',/*Firefox 3.5+*/
                    transform: 'rotate(45deg)',
                    margin:'-250px 0px',
                    fontSize:'2.3em',
                    textAlign:'center',
                    color:'#ddd',
                    opacity:0.3,
                    }}>
                    <p style={{margin:'30px 40px 20px 20px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'40px 30px 25px 30px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'30px 20px 10px 40px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'20px 35px 30px 25px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'10px 30px 50px 30px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'35px 15px 30px 25px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'50px 40px 20px 20px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'25px 20px 10px 40px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'35px 30px 25px 30px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'10px 20px 30px 40px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'30px 40px 20px 20px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'40px 30px 25px 30px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'30px 20px 10px 40px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'20px 35px 30px 25px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'10px 30px 50px 30px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'35px 15px 30px 25px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'50px 40px 20px 20px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'25px 20px 10px 40px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'35px 30px 25px 30px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'10px 20px 30px 40px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'30px 40px 20px 20px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'40px 30px 25px 30px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'30px 20px 10px 40px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'20px 35px 30px 25px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'10px 30px 50px 30px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'35px 15px 30px 25px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'50px 40px 20px 20px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'25px 20px 10px 40px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'35px 30px 25px 30px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'10px 20px 30px 40px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'30px 40px 20px 20px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'40px 30px 25px 30px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'30px 20px 10px 40px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'20px 35px 30px 25px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'10px 30px 50px 30px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'35px 15px 30px 25px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'50px 40px 20px 20px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'25px 20px 10px 40px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'35px 30px 25px 30px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'10px 20px 30px 40px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'30px 40px 20px 20px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'40px 30px 25px 30px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'30px 20px 10px 40px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'20px 35px 30px 25px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'10px 30px 50px 30px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'35px 15px 30px 25px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'50px 40px 20px 20px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'25px 20px 10px 40px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'35px 30px 25px 30px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'10px 20px 30px 40px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'30px 40px 20px 20px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'40px 30px 25px 30px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'30px 20px 10px 40px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'20px 35px 30px 25px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'10px 30px 50px 30px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'35px 15px 30px 25px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'50px 40px 20px 20px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'25px 20px 10px 40px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'35px 30px 25px 30px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'10px 20px 30px 40px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'30px 40px 20px 20px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'40px 30px 25px 30px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'30px 20px 10px 40px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'20px 35px 30px 25px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'10px 30px 50px 30px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'35px 15px 30px 25px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'50px 40px 20px 20px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'25px 20px 10px 40px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'35px 30px 25px 30px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'10px 20px 30px 40px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'30px 40px 20px 20px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'40px 30px 25px 30px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'30px 20px 10px 40px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'20px 35px 30px 25px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'10px 30px 50px 30px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'35px 15px 30px 25px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'50px 40px 20px 20px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'25px 20px 10px 40px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'35px 30px 25px 30px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'10px 20px 30px 40px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'30px 40px 20px 20px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'40px 30px 25px 30px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'30px 20px 10px 40px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'20px 35px 30px 25px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'10px 30px 50px 30px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'35px 15px 30px 25px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'50px 40px 20px 20px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'25px 20px 10px 40px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'35px 30px 25px 30px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'10px 20px 30px 40px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'30px 40px 20px 20px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'40px 30px 25px 30px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'30px 20px 10px 40px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'20px 35px 30px 25px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'10px 30px 50px 30px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'35px 15px 30px 25px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'50px 40px 20px 20px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'25px 20px 10px 40px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'35px 30px 25px 30px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                    <p style={{margin:'10px 20px 30px 40px',display:'inline-block',fontFamily:'宋体'}}> {userName}</p>,
                  </div>
                </div>
                <div style={{
                    position:'absolute',
                    width:'85%',
                    minWidth     : '900px',
                    left    : '7%',
                    zIndex:5
                }} ref="divDome">
                    <Section0 enclosureShow={this.enclosureShow}/>
                    <Section1/>
                    <Section2 enclosureShow={this.enclosureShow}/>
                    <Section3 enclosureShow={this.enclosureShow}/>
                    <Section4 enclosureShow={this.enclosureShow}/>
                    <Section5 enclosureShow={this.enclosureShow}/>
                    <Section6 enclosureShow={this.enclosureShow}/>
                    <Section7/>
                    <Section8/>
                    <Section9 enclosureShow={this.enclosureShow}/>
                    <Section10 enclosureShow={this.enclosureShow}/>
                    <Section11/>
                    <Section12/>
                    <Section13/>
                    <Section14/>
                </div>
                {/*附件*/}
                <Index visible={visible} id={id} title={title} enclosureClose={this.enclosureClose}/>

            </div>);
    }
}

export default Article;
